<template>
  <nav class="navbar">
    <button class="menu-icon">
      <icon feather="menu"></icon>
    </button>
    <dropdown class="right">
      <button slot="button" class="navbar_profile dropdown-button">
        <!-- <div class="profile_user" v-if="user">
          <span class="username">
            {{ user.nombre }}
          </span>
          <span class="role">
            {{ user.tipo.toUpperCase() }}
          </span>
        </div>
        <div class="profile_thumbnail">{{ acronimo() }}</div> -->
        <!-- <img class="profile_thumbnail" src="images/profile.jpg" alt=""> -->
        <span>Mi perfil </span><icon :feather="'chevron-down'"></icon>
      </button>
      <template slot="content">
        <p class="list-title">Mi perfil</p>
        <ul class="list">
          <li class="list-item">
            <router-link :to="{ name: 'MisDatos' }">Mis datos</router-link>
          </li>
          <li class="list-item">
            <router-link :to="{ name: 'CambiarPassword' }"
              >Cambiar contraseña</router-link
            >
          </li>
          <li class="list-item" v-if="user && user.tipo === 'dev'">
            <a href="#" @click="openImpersonateModal">Cambiar de usuario</a>
          </li>
          <hr />
          <li class="list-item">
            <a class="" href="#" @click="logout">Cerrar sesión</a>
          </li>
        </ul>
      </template>
    </dropdown>

    <!-- Modal para cambiar de usuario -->
    <Modal v-if="showImpersonateModal" @close="closeImpersonateModal">
      <div slot="modal-body" style="width: 600px; max-width: 100%">
        <h3 class="mb-3">Cambiar de usuario (Modo desarrollador)</h3>

        <div class="mb-3">
          <label class="form-label">Buscar usuario:</label>
          <input
            v-model="searchUser"
            type="text"
            class="form-control"
            placeholder="Buscar por nombre, CUIL o área..."
            @input="filterUsers"
          />
        </div>

        <div class="users-list" style="max-height: 400px; overflow-y: auto">
          <div
            v-for="user in filteredUsers"
            :key="user.id"
            class="user-item"
            @click="selectUser(user)"
            :class="{
              selected: selectedUser && selectedUser.id === user.id,
              'hover-effect': true,
            }"
          >
            <div class="user-info">
              <div class="user-header">
                <strong>{{ user.nombre }}</strong>
                <div
                  class="selection-indicator"
                  v-if="selectedUser && selectedUser.id === user.id"
                >
                  ✓
                </div>
              </div>
              <div class="user-details">
                <span class="badge badge-primary">{{ user.tipo }}</span>
                <span class="text-secondary">{{ user.cuil }}</span>
              </div>
              <div class="user-area" v-if="user.area || user.gerencia">
                <small class="text-muted">
                  {{ user.area }}
                  {{ user.gerencia ? " - " + user.gerencia : "" }}
                </small>
              </div>
            </div>
          </div>

          <div v-if="filteredUsers.length === 0" class="no-users">
            <p class="text-muted">No se encontraron usuarios</p>
          </div>
        </div>

        <div class="mt-4 d-flex justify-content-between align-items-center">
          <div v-if="selectedUser" class="selected-user-info">
            <small class="text-muted">Usuario seleccionado:</small>
            <div>
              <strong>{{ selectedUser.nombre }}</strong> ({{
                selectedUser.tipo
              }})
            </div>
          </div>
          <div v-else class="selected-user-info">
            <small class="text-muted">Seleccione un usuario de la lista</small>
          </div>

          <div class="button-group">
            <button
              @click="closeImpersonateModal"
              class="btn btn-secondary mr-2"
            >
              Cancelar
            </button>
            <button
              @click="impersonateUser"
              class="btn btn-primary"
              :disabled="!selectedUser"
            >
              {{
                selectedUser
                  ? `Cambiar a ${selectedUser.nombre.split(" ")[0]}`
                  : "Seleccione usuario"
              }}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </nav>
</template>
<script>
import Vuex from "vuex";
import Modal from "../elements/Modal.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "Navbar",
  components: {
    Modal,
  },
  data() {
    return {
      showImpersonateModal: false,
      users: [],
      filteredUsers: [],
      selectedUser: null,
      searchUser: "",
    };
  },
  computed: {
    ...Vuex.mapState(["user"]),
  },
  mounted() {},
  methods: {
    // acronimo() {
    //   let str = this.user.nombre;
    //   let matches = str.match(/\b(\w)/g); // ['J','S','O','N']
    //   let acronym = matches.join(""); // JSON
    //   return acronym;
    // },
    ...Vuex.mapActions({
      logoutAction: "logout",
    }),
    logout() {
      this.logoutAction().then(() => {
        this.$router.push({
          name: "Login",
        });
      });
    },
    async openImpersonateModal() {
      this.showImpersonateModal = true;
      try {
        const response = await axios.get("auth/users-for-impersonate");
        this.users = response.data;
        this.filteredUsers = response.data;
      } catch (error) {
        console.error("Error cargando usuarios:", error);
        Swal.fire("Error", "No se pudieron cargar los usuarios", "error");
        this.closeImpersonateModal();
      }
    },
    closeImpersonateModal() {
      this.showImpersonateModal = false;
      this.users = [];
      this.filteredUsers = [];
      this.selectedUser = null;
      this.searchUser = "";
    },
    filterUsers() {
      const search = this.searchUser.toLowerCase();
      this.filteredUsers = this.users.filter(
        (user) =>
          user.nombre.toLowerCase().includes(search) ||
          user.cuil.includes(search) ||
          user.tipo.toLowerCase().includes(search) ||
          (user.area && user.area.toLowerCase().includes(search)) ||
          (user.gerencia && user.gerencia.toLowerCase().includes(search))
      );
    },
    selectUser(user) {
      this.selectedUser = user;
      console.log("Usuario seleccionado:", user); // Para debug
    },
    async impersonateUser() {
      if (!this.selectedUser) return;

      const confirmResult = await Swal.fire({
        title: "¿Confirmar cambio de usuario?",
        html: `¿Está seguro de cambiar a:<br><strong>${this.selectedUser.nombre}</strong><br>(${this.selectedUser.tipo})`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, cambiar",
        cancelButtonText: "Cancelar",
      });

      if (!confirmResult.isConfirmed) return;

      try {
        const response = await axios.post(
          `auth/impersonate/${this.selectedUser.id}`
        );

        if (response.data.success) {
          // Guardar el token e información del usuario
          localStorage.setItem("access_token", response.data.access_token);

          // Actualizar el store con el nuevo token y usuario
          await this.$store.dispatch("attempt", response.data.access_token);

          Swal.fire(
            "Cambio exitoso",
            `Ahora está operando como: ${response.data.user.persona.nombre}`,
            "success"
          );

          this.closeImpersonateModal();

          // Opcional: recargar la página o redirigir
          this.$router.push("/");
        }
      } catch (error) {
        console.error("Error al cambiar de usuario:", error);
        Swal.fire("Error", "No se pudo cambiar de usuario", "error");
      }
    },
  },
};
</script>

<style scoped>
.users-list {
  border: 1px solid #ddd;
  border-radius: 0.375rem;
}

.user-item {
  padding: 1rem;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.user-item:hover {
  background-color: #f8f9fa;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.user-item.selected {
  background-color: #e3f2fd !important;
  border-left: 4px solid #007bff;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.2);
}

.user-item.selected:hover {
  background-color: #bbdefb !important;
}

.user-item:last-child {
  border-bottom: none;
}

.user-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.user-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.selection-indicator {
  color: #007bff;
  font-weight: bold;
  font-size: 1.2rem;
  background: white;
  border: 2px solid #007bff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.no-users {
  padding: 2rem;
  text-align: center;
}

.user-details {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.badge {
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: bold;
}

.badge-primary {
  background-color: #007bff;
  color: white;
}

.text-secondary {
  color: #6c757d;
}

.text-muted {
  color: #6c757d;
}

.form-control {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #ddd;
  border-radius: 0.375rem;
}

.form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  display: block;
}

.mt-4 {
  margin-top: 1.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.d-flex {
  display: flex;
}

.justify-content-end {
  justify-content: flex-end;
}

.justify-content-between {
  justify-content: space-between;
}

.align-items-center {
  align-items: center;
}

.selected-user-info {
  flex: 1;
  margin-right: 1rem;
}

.button-group {
  display: flex;
  gap: 0.5rem;
}

.btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  text-decoration: none;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
